import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: { user },
  getters: {
    token: state => state.user.token,
    user: state => state.user.user,
    org: state => state.user.org,
    profile: state => state.user.profile,
    menus: state => state.user.menus,
    orgName: state => (state.user.org && state.user.org.name) || '',
    orgTypeLabel: state => {
      const type = state.user.org && state.user.org.type
      const map = {
        education: '教育局',
        tourism: '文旅局',
        base: '研学基地',
        school: '学校',
        transport: '运输公司',
        hotel: '酒店',
        restaurant: '餐厅'
      }
      return map[type] || '机构'
    },
    orgOpened: state => {
      const org = state.user.org
      if (!org) return false
      if (org.type === 'tourism' || org.type === 'education') return true
      return Number(org.audit_status) === 2
    }
  }
})

export default store
